package fr.manyverse.app.presentation.components.modules.lockpicking

import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Key
import androidx.compose.material3.FloatingActionButton
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import manyverse.shared.generated.resources.Res
import manyverse.shared.generated.resources.lockpicking_open
import org.jetbrains.compose.resources.stringResource

@Composable
fun LockpickingBubble(
    onClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    FloatingActionButton(
        onClick = onClick,
        containerColor = MaterialTheme.colorScheme.primaryContainer,
        modifier = modifier
    ) {
        Icon(Icons.Default.Key, contentDescription = stringResource(Res.string.lockpicking_open))
    }
}
